import useTranslate from '@core/hooks/useTranslate';
import Statistics from '@root/core/components/Statistics';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import CardItem from '@root/modules/Sellers/Dashboard/components/CardItem';
import PageTop from '@root/modules/Sellers/Dashboard/components/PageTop/index';
import TitleTable from '@root/modules/Sellers/Dashboard/components/TitleTable';
import SellerServices from '@root/modules/Sellers/Dashboard/services/dashboard';
import { Card, Col, Divider, Row } from 'antd';
import { Header } from 'antd/lib/layout/layout';
import moment from 'moment';
import { useEffect, useState } from 'react';
import ListStockDashboard from '../components/ListStockDashboard';

interface Props {}

const breadcrumbList = [
  {
    label: 'seller:sidebar:dashboard',
    url: '/admin/seller'
  }
];

const SellersPage = (props: Props) => {
  const [t] = useTranslate();
  const { data } = useTypedSelector((state) => state.userReducer);

  const [label, setLabel] = useState<
    { id: number; label: string; number: number }[]
  >([
    {
      id: 1,
      label: t('seller:card:total'),
      number: 0
    },
    {
      id: 2,
      label: t('seller:card:total-shipping'),
      number: 0
    },

    {
      id: 3,
      label: t('seller:card:return'),
      number: 0
    },
    {
      id: 4,
      label: t('seller:card:shipping'),
      number: 0
    },
    {
      id: 5,
      label: t('seller:card:delivery'),
      number: 0
    }
  ]);

  const [listDashboardRight, setListDashboardRight] = useState([]);
  const [listStock, setListStock] = useState([]);
  const [listOrder, setListOrder] = useState([]);
  const [isGetOrder, setIsGetOrder] = useState(false);

  const getListOrderToday = async () => {
    const warehouse = await SellerServices.getContactWarehouse();
    setListDashboardRight(warehouse.data);
  };

  const getListStock = async () => {
    const stockList = await SellerServices.getDashboardStock();
    setListStock(stockList.data);
  };

  const getListOrder = async () => {
    const orderList = await SellerServices.getDashboardOrder();
    let listOrderUse =
      !!orderList?.data && orderList.data.length > 0
        ? orderList.data.map((item: any) => ({
            ...item,
            orderDateUse: moment(item.orderDate).utc().format('YYYY-MM-DD')
          }))
        : [];
    setListOrder(listOrderUse);
  };

  const getIsGetOrder = async () => {
    const orderIsGet = await SellerServices.isGetOrder();
    setIsGetOrder(orderIsGet.data);
  };

  const getDashboardSummary = async () => {
    const {data} = await SellerServices.getDashboardSummary();
    setLabel((label) => {
      label[0].number = data[0];
      label[1].number = data[1];
      label[2].number = data[2];
      label[3].number = data[3];
      label[4].number = data[4];
      return [...label];
    });
  }

  useEffect(() => {
    getListOrderToday();
    getDashboardSummary();
    getListStock();
    getIsGetOrder();
  }, []);

  useEffect(() => {
    if (isGetOrder) getListOrder();
  }, [isGetOrder]);

  return (
    <>
      <Header className="header-page-top">
        <PageTop
          breadcrumbList={breadcrumbList}
          title={t('seller:sidebar:dashboard')}
          t={t}
        />
      </Header>
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <div className="site-card-wrapper">
            <Row gutter={8}>
              {label.map((item, index) => (
                <Statistics
                  title={item.label}
                  number={item.number}
                  key={index + 100}
                />
              ))}
            </Row>
          </div>
          <div
            style={{
              marginTop: '2rem'
            }}
          >
            <Row>
              <Col span={12}>
                <div
                  style={{
                    backgroundColor: 'white'
                  }}
                >
                  <TitleTable
                    nameTable="재고 소진 임박"
                    title="더보기"
                    url="/admin/seller/stock"
                  />
                  <Divider style={{ margin: 0 }} />
                  {(listStock || []).map((item: any, index: number) => (
                    <ListStockDashboard
                      key={index}
                      id={item.id}
                      productName={item.productName}
                      UPC={item.eanUpc}
                      warehouseName={item?.quotation?.warehouse?.name ?? ''}
                      warehouseAddress={
                        item?.quotation?.warehouse?.detailAddress ?? ''
                      }
                      quantity={item?.inventory?.remainQuantity ?? 0}
                      img={item?.image?.url ?? ''}
                    />
                  ))}
                </div>
                <div
                  style={{
                    backgroundColor: 'white',
                    marginTop: '5%'
                  }}
                >
                  <TitleTable
                    nameTable="잔여 재고 이상으로 주문이 들어온 건"
                    title="더보기"
                    url="/admin/seller/shipping-create"
                  />
                  <Divider style={{ margin: 0 }} />
                  {(listOrder || []).map((item: any, index) => (
                    <CardItem
                      isOrder={true}
                      key={index + 30}
                      UPC={item.orderProducts[0].product.eanUpc}
                      orderNumber={item.orderNumber}
                      productName={item.orderProducts[0].product.productName}
                      orderDate={item.orderDateUse}
                      amount={'개수'}
                      amountNumber={item.orderProducts[0].orderQuantity}
                      url={`/admin/seller/shipping/${item.id}`}
                    />
                  ))}
                </div>
              </Col>
              <Col span={12}>
                <div
                  style={{
                    backgroundColor: 'white',
                    marginLeft: '5%'
                  }}
                >
                  <TitleTable
                    nameTable="이용중인 물류센터"
                    title="더보기"
                    url="/admin/seller/stock"
                  />
                  <Divider style={{ margin: 0 }} />
                  {(listDashboardRight || []).map(
                    (item: any, index: number) => (
                      <CardItem
                        isOrder={false}
                        key={index + 60}
                        id={item.id}
                        UPC={item.name}
                        nameCenter={item.nameCenter}
                        amount={'보관 상품'}
                        desUPC={item.address}
                        desCenter={item.desSecond}
                        image={item?.images[0]?.url ?? ''}
                        url={`/admin/seller/stock/${item.id}`}
                        amountNumber={item.numberOfProduct}
                      />
                    )
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </Card>
      </div>
    </>
  );
};

export default SellersPage;
